import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icons } from '@techsoftware/happay-widgets';
import LightBox from '@techsoftware/happay-widgets/LightBox';

export default function AttachmentFormatter(props) {
  const { type, data } = props;
  const [openLightBox, setOpenLightBox] = useState(false);
  return (
    <div onClick={e => e.stopPropagation()}>
      {data && data.length > 0 && (
        <div
          onClick={() => setOpenLightBox(true)}
          style={{ display: 'inline-flex' }}
        >
          <Icons type="clip" size="medium" />
          {data.length}
        </div>
      )}
      {openLightBox && (
        <LightBox
          index={0}
          open={openLightBox}
          onClose={() => setOpenLightBox(false)}
          urls={data}
        />
      )}
    </div>
  );
}
AttachmentFormatter.propTypes = {
  type: PropTypes.string,
  data: PropTypes.array,
};
AttachmentFormatter.defaultProps = {
  type: '',
  data: [],
};
